"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _cccisdFormik = require("cccisd-formik");
var _helpers = require("../../helpers");
var _TabName = _interopRequireDefault(require("./TabName"));
var _PageWidth = _interopRequireDefault(require("./PageWidth"));
var _Introduction = _interopRequireDefault(require("./Introduction"));
var _LearningObjectives = _interopRequireDefault(require("./LearningObjectives"));
var _Presenters = _interopRequireDefault(require("./Presenters"));
var _IconAndDescription = _interopRequireDefault(require("./IconAndDescription"));
var _FinalTestInstructions = _interopRequireDefault(require("./FinalTestInstructions"));
var _CeApprovalStatements = _interopRequireDefault(require("./CeApprovalStatements"));
var _SpecialAssistance = _interopRequireDefault(require("./SpecialAssistance"));
var _Acknowledgements = _interopRequireDefault(require("./Acknowledgements"));
var _users = _interopRequireDefault(require("cccisd-icons/users4"));
var _database = _interopRequireDefault(require("cccisd-icons/database"));
var _stopwatch = _interopRequireDefault(require("cccisd-icons/stopwatch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var initialValues = {
  toggle: false,
  tabName: 'Course Description',
  pageWidth: 'medium',
  introduction: {
    title: '',
    main: '',
    courseSections: [{
      heading: '',
      description: '',
      key: 0
    }]
  },
  learningObjectives: {
    title: '',
    sections: [{
      heading: '',
      statement: '',
      objectives: [{
        text: '',
        key: 0
      }],
      key: 0
    }]
  },
  presenters: {
    title: '',
    sections: [{
      name: '',
      title: '',
      position: '',
      bio: '',
      image: '',
      key: 0
    }]
  },
  audience: {
    title: '',
    description: '',
    icon: 'default',
    iconColor: '#0361B0',
    imageDetails: ''
  },
  creditHours: {
    title: '',
    description: '',
    icon: 'default',
    iconColor: '#0361B0',
    imageDetails: ''
  },
  duration: {
    title: '',
    description: '',
    icon: 'default',
    iconColor: '#0361B0',
    imageDetails: ''
  },
  finalTestInstructions: {
    title: '',
    statement: '',
    bullets: [{
      text: '',
      key: 0
    }]
  },
  ceApprovalStatements: {
    title: '',
    sections: [{
      title: '',
      subtitle: '',
      description: '',
      key: 0
    }]
  },
  specialAssistance: {
    title: '',
    content: ''
  },
  acknowledgements: {
    title: '',
    content: '',
    displayInModal: false
  },
  tableOfContents: false
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.courseDescription.toggle) {
    if (!values.courseDescription.tabName) {
      localErrors['courseDescription.tabName'] = 'Tab Name is required';
    }
    var keysOfInterest = Object.keys(initialValues).filter(function (key) {
      return !['toggle', 'tabName'].includes(key);
    });
    var valuesOfInterest = (0, _pick2["default"])(values.courseDescription, keysOfInterest);
    var onlyValues = Object.values(valuesOfInterest);
    if (onlyValues.every(function (item) {
      return item === '';
    })) {
      var _iterator = _createForOfIteratorHelper(keysOfInterest),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          localErrors["courseDescription.".concat(key)] = 'At least one of the course description fields must be non-empty';
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'courseDescription',
  key: 'courseDescription'
};
exports.formCoupler = formCoupler;
var FormCourseDescription = function FormCourseDescription(_ref) {
  var formProps = _ref.formProps;
  var renderToggleField = function renderToggleField() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseDescription.toggle",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Course Description Tab",
        tooltip: "Should we show a Course Description tab?"
      }),
      autoFocus: true
    }));
  };
  var renderConditionalFields = function renderConditionalFields() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseDescription.tableOfContents",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Table of Contents",
        tooltip: "Should we show a Table of Contents?"
      })
    }), /*#__PURE__*/_react["default"].createElement(_TabName["default"], null), /*#__PURE__*/_react["default"].createElement(_PageWidth["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_Introduction["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_LearningObjectives["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_Presenters["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_IconAndDescription["default"], {
      heading: "Audience",
      name: "audience",
      DefaultIcon: _users["default"],
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_FinalTestInstructions["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_IconAndDescription["default"], {
      heading: "Credit Hours",
      name: "creditHours",
      DefaultIcon: _database["default"],
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_IconAndDescription["default"], {
      heading: "Duration",
      name: "duration",
      DefaultIcon: _stopwatch["default"],
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_CeApprovalStatements["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_SpecialAssistance["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_Acknowledgements["default"], {
      formProps: formProps
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderToggleField(), formProps.values.courseDescription.toggle && renderConditionalFields());
};
var _default = FormCourseDescription;
exports["default"] = _default;